import { fetchLuxPlusPreferredPaymentCard } from 'actions/LuxPlusActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

/**
 * @returns the stored off-session card that will be used to charge a LuxPlus+ member
 * their annual subscription fee, and any error that occurred while fetching it.
 */
function useLuxPlusPreferredPaymentCard(refreshKey?: number): App.StatefulData<App.StripePaymentCardV2> | undefined {
  const dispatch = useAppDispatch()
  const { preferredPaymentCard } = useAppSelector(
    state => state.auth.account.luxPlus.member.subscription,
  )

  useEffect(() => {
    dispatch(fetchLuxPlusPreferredPaymentCard())
  }, [dispatch, refreshKey])

  return preferredPaymentCard
}

export default useLuxPlusPreferredPaymentCard
